import { render, staticRenderFns } from "./DescargarListadoEnvios.vue?vue&type=template&id=68712359"
import script from "./DescargarListadoEnvios.vue?vue&type=script&lang=js"
export * from "./DescargarListadoEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports